import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import {DemoService} from '../../../demo.service';
import { DatePipe } from '@angular/common';

import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { enableRipple } from '@syncfusion/ej2-base';

enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';

import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';
import {  IFilter } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { delay ,  pipe , map} from 'rxjs';

import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { TabsetComponent } from 'ngx-bootstrap';
import { GlobalFunctionsService } from '../../../services/global-functions.service';
import { LegalDateTimeService } from '../../../services/legal-datetime.service';
import { JobSubject } from 'src/app/shared/models/jobSubject.model';
import { Brand } from 'src/app/shared/models/brand.model';

@Component({
  selector: 'app-jobs-sorting',
  templateUrl: './jobs-sorting.component.html',
  styleUrls: ['./jobs-sorting.component.scss']
})
export class JobsSortingComponent implements OnInit {


  job_table: any;
  result: any;
  client_name: any;
  persons: any;
  job_table2: any;
  client_name_value: any;
 responseDelay = 2000;
  clients: any;
  clientLocalRecord: any;
  job_types: any;
  subjects: any;
  agents_assigned: any;
  staffList: any;
  items?: any[];
  data_subjects2: any;
  initialPage!: PageSettingsModel;

  jobTypesLocalRecord: any;
  changeObject: any;

  subjectLocalRecord: any;

  createdAt: any;
  nextDateLocalRecord: any;

  agentsAssignedLocalRecord: any;
  allocated_agents_list: any;

  public data!: DataManager;
  public data_subjects!: DataManager;
  public pageSettings?: Object;
  public pageOptions = { pageSize: 100 }; 
  public filterOptions?: FilterSettingsModel;
  public formatOptions?: Object;
  // public filterOptions: FilterSettingsModel;
  public filter! : IFilter;
  public toolbarOptions!: ToolbarItems[];
  @ViewChild('grid')
  public grid!: GridComponent;
  public groupOptions!: GroupSettingsModel;
  public templateOptionsDate!: IFilterUI;
  public elem1!: HTMLElement;
  public datePickerObj!: DatePicker;

  job_table3: any; // filtered results of job table2 to load properly
  brands: any;
  brandsLocalRecord: any;
  brandLocalRecord: any;
  subject_agents_assigned: any;
  subjectsAssignedLocalRecord: any;
  allocated_agents_subject_list: any;
  brandAgentsList: any;
  assignedBrandList: any;
  subjects_urgent: any;

  formatoptions?: { type: string; format: string; };
  dateFormat?: string;
  sortOptions?: { columns: { field: string; direction: string; }[]; };
  today = new Date();

  search_model: JobSubject;

  // TABS sets the selected
  @ViewChild('staticTabs') staticTabs!: TabsetComponent;
  selected_tab?: number;
  job_status_run: Object;
  job_status_data: any;
  brands_client: any;

  combo_model: Brand;
  sent_brand_id: any;
  brand_users: any;
  brand_users_data: Object;
  brand_report_selected: Object;
  selected_brand_data: any;

  public brand_fields: Object = { text: 'NameAndAddress', value: 'brand_id' };
client_fields: Object = { text: 'user_full_name', value: 'user_id' };
  loaded_4: number;
  loaded_0: number;
  loaded_1: number;
  loaded_2: number;
  loaded_3: number;

  constructor(
    private http: HttpClient, private router: Router, route: ActivatedRoute,private _demoService: DemoService,
    public datepipe: DatePipe, public gfunc: GlobalFunctionsService, public legalDate: LegalDateTimeService
  ) {

  }


  ngOnInit() {



    // this.getJobsTableData(); // new table data // IS THIS REQUIED AT ALL!!!! sept 2024 --- nooooo yes so much qyicker now.

   // this.mapJobTableLive(); // load the table data
  
    this.toolbarOptions = ['ExcelExport', 'Search'];
    this.initialPage = { pageSize:5 };
    this.filterOptions = {
       type: 'Menu'
    };
   this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
    this.formatoptions= {type:'date', format:'dd/MM/yyyy'};
    this.dateFormat = 'dd/MM/yyyy hh:mm a';
    this.filter = { params: { format: this.dateFormat } };
    this.sortOptions = { columns: [{ field: 'job_id', direction: 'Descending' } ] };


// end date filter options
  }


ngOnDestroy(){
 //  this.result.unsubsribe();
}



// New way of rendering table data
mapJobTableLive() {

  this.getClients(); // load clients first
  this.getJobTypes();
  this.getJobSubjectsAll();
  this.getBrandUsers('94'); // for sharmans only
  this.getJobAgentsAllAssigned();
  this.getBrands(); //
  this.getJobAgentsAllAssigned();
  this.getSubjectAgentsAssignedAll();

 

  this.http.get<any>(this.gfunc.apiURL + '/api/job/table/all/open')
 .pipe(map(data => {
  // do your transformations
  this.job_table2 = data;

  this.job_table2.forEach(element => {

// local Client Name
/*
this.clientLocalRecord = this.clients.filter(c => c.client_id === element.client_id);
let rs = this.clientLocalRecord;
this.changeObject = Object.assign(this.clientLocalRecord);
element.client_id  = this.changeObject[0].name;
*/
// get brand_report_id // client brand Name

this.brandLocalRecord = this.brands.filter(c => c.brand_id === element.brand_report_id);
this.changeObject = Object.assign(this.brandLocalRecord);
element.brand_report_id  = this.changeObject[0].name;


// Get Job Types
this.jobTypesLocalRecord = this.job_types.filter(c => c.job_type_id === element.job_type_id);
this.changeObject = Object.assign(this.jobTypesLocalRecord);
element.job_type_id  = this.changeObject[0].job_type_name;
// Get Job Subject Name
this.subjectLocalRecord = this.subjects.filter(c => c.subject_id === element.subject_id);
this.changeObject = Object.assign(this.subjectLocalRecord);
if (this.changeObject[0].first_name === null){
 // element.subject_id = '-';
  element.subject_name = '-';
}else{
 // element.subject_id  = this.changeObject[0].first_name + ' ' + this.changeObject[0].surname;
element.subject_name = this.changeObject[0].first_name + ' ' + this.changeObject[0].surname;
}

this.setLegalGridDateFields(element);
// Agents Assigned
// this.agentsAssignedLocalRecord = this.agents_assigned.filter(c => c.job_id === element.job_id); // old version
this.agentsAssignedLocalRecord = this.agents_assigned.filter(c => c.subject_id === element.subject_id);
this.changeObject = Object.assign(this.agentsAssignedLocalRecord);
let recordCount = this.changeObject.length;
console.log(recordCount);
this.allocated_agents_list = '';
if (recordCount < 1){
  this.allocated_agents_list = '-';
}else{
  for (let i = 0; i < recordCount; i++) {
// this.allocated_agents_list  += this.changeObject[i].first_name + ' ' + this.changeObject[i].surname + ', ';
this.allocated_agents_list  += this.changeObject[i].name + ', ';
} // end loop
}
element.allocated_to  = this.allocated_agents_list;



}); // end for each of all


return this.job_table2;

}))

  .subscribe(results => this.job_table2 = results
  );

}

private setLegalGridDateFields(element: any): void {
['next_date', 'final_date', 'hearing_date', 'judgement_date', 'filing_date', 'instructions_date', 'aos_date']
  .forEach((field) => {
    element[`${field}_display`] = this.legalDate.format(element[field], 'DD/MM/YYYY h:mm a');
    element[`${field}_search`] = this.legalDate.format(element[field], 'YYYY-MM-DD');
  });
}



  /// TABS
  selectTab(tab_id: number) {
    this.staticTabs.tabs[tab_id].active = true;
    this.selected_tab = tab_id; // so that we can load the queries only when the tabs clicked

  if(tab_id == 0) { this.loaded_0 = 1}
  if(tab_id == 1) { this.loaded_1 = 1}
  if(tab_id == 2) { this.loaded_2 = 1}
  if(tab_id == 3) { this.loaded_3 = 1}
  if(tab_id == 4) { this.loaded_4 = 1}

  };

// get the mapping stuff

getClients() {
  this._demoService.getClients().subscribe(
     data => { this.clients = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

// need to get new clients
getBrands() {
  this._demoService.getBrands().subscribe(
     data => { this.brands = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



 getJobTypes() {
  this._demoService.getJobTypes().subscribe(
     data => { this.job_types = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getJobSubjectsAll() {
  this._demoService.getJobSubjectsAll().subscribe(
     data => { this.subjects = data;
      let res = data[0];
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 getJobAgentsAllAssigned() {
  this._demoService.getSubjectBrandAgentsAssignedAll().subscribe(
     data => { this.agents_assigned = data;
      let res = data[0];
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 

 getSubjectAgentsAssignedAll(){
  this._demoService.getSubjectAgentsAssignedAll().subscribe(
    data => { this.subject_agents_assigned = data;
     let res = data[0];
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
 }


  // need to get brand agents.
  getBrandAgents() {
    this._demoService.getBrandAgents().subscribe(
       data => { this.brandAgentsList = data;
      },
       err => console.error(err),
       // () => console.log('Agent Brands Loaded.')
     );
   }



   getSubjectAgentBrandsAssigned(subject_id) {
    this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
       data => { this.assignedBrandList = data;
      },
       err => console.error(err),
       // () => console.log('Loaded Assigned Agents Loaded.')
     );
   }


// gets the list of users assiciated for drop down.
getBrandUsers(brand_id) {
  this._demoService.getBrandUsers(brand_id).subscribe(
     data => { this.staffList = data;
    },
     err => console.error(err),
     () => console.log('Candidates Loaded.')
   );
 }




 toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }
}
rowDataBound(args: RowDataBoundEventArgs): void {
  const job_status = 'job_status';
  // if (args.data[job_status] === 'CLOSED') {
  //     args.row.className = 'strikethrough';
  // }
}



jobLink(job_id) {
  this.router.navigate(['/admin/jobs/create-job-3/' + job_id + '']);
}

jobView(job_id) {
  this.router.navigate(['/admin/jobs/view/' + job_id + '']);
}

subjectEdit(subject_id){
  this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + '']);
}


refreshGrid(){ // refresh the databutton
  //this.mapJobTableLive();
  this.getJobsTableData();
  this.grid.refresh();
};





getJobsTableData() {
  this._demoService.getJobsTableData().subscribe(
    (data: any) => { this.subjects_urgent = data;
      // pass so that the dates are correct in Sync
      // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
      this.subjects_urgent = DataUtil.parse.parseJson(data);
      this.subjects_urgent.forEach((row) => this.setLegalGridDateFields(row));
     // console.log("Done loadng USER");
     // console.log(this.users);


    },
    error => {
    //  console.error('Error Loading User!');
    // return Observable.throw(error);
    }
  ); }




   }
